import React from "react";
import { makeStyles, useId } from "@fluentui/react-components";
import { useOptionDrawerStore } from "../store/OptionDrawerStore";

const useStyles = makeStyles({
    drawerBody: {
        overflow: "hidden"
    },
    inputWrapper: {
        paddingBottom: "15px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        maxWidth: "400px",
        "> div": { display: "flex", flexDirection: "column", gap: "2px" },
    },
});

export default function useOptionFormHook() {
    const styles = useStyles();
    const { isEdit, data } = useOptionDrawerStore();

    const nameId = useId("option-name");
    const [name, setName] = React.useState<string>(isEdit && data ? data.name : "");

    const orderId = useId("order-id");
    const [order, setOrder] = React.useState<number>(isEdit && data ? data.order : 1);

    return { styles, nameId, name, setName, orderId, order, setOrder };
}